export const DEVICE_CHARACTERISTICS = [
    {
        value: 'SaMD / AI-ML',
        definition: 'Software as a Medical Device, including those using artificial intelligence or machine learning algorithms',
    },
    {
        value: 'Implantable',
        definition: 'Fully or partially inserted into the body, surgically or naturally, and intended to remain after the procedure',
    },
    {
        value: 'Active',
        definition: 'Relies on an electrical energy source or energy conversion for its function',
    },
    {
        value: 'IVD',
        definition: 'In Vitro Diagnostic, used to examine specimens derived from the human body such as blood or tissue',
    },
    {
        value: 'Custom-made',
        definition: 'Made specifically for an individual patient, includes 3D-printed custom-made implants for example',
    },
    {
        value: 'Single-use',
        definition: 'Intended for one use on one patient, not to be reprocessed or reused',
    },
    {
        value: 'Sterile',
        definition: 'Delivered in a sterile state by the manufacturer',
    },
    {
        value: 'With measuring function',
        definition: 'Has a measuring function that can affect patient diagnosis or treatment',
    },
    {
        value: 'Combination product (drug/device, biologic/device)',
        definition: 'Incorporates a medicinal substance, biological component, or tissue as an integral part',
    },
    {
        value: 'Contains animal/human tissue',
        definition: 'Manufactured utilizing tissues or cells of animal or human origin, or their derivatives',
    },
];
//# sourceMappingURL=device-characteristics.js.map